export default {"src":"/_next/static/media/phone.781de1fd.svg","height":50,"width":36,"blurWidth":0,"blurHeight":0};